module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-1-ac1ea986ea9b52c95fed26447e4eeabd.png";